import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/common/Reveal";
import MagneticButton from "@/components/common/MagneticButton";
import logo from "@/assets/logo.png";

export default function Footer() {
  return (
    <footer className="relative border-t border-[var(--hairline)] bg-[var(--body-bg)]" data-testid="footer">
      <div className="container-x py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <Reveal direction="up" className="md:col-span-5">
            <div>
              <div className="flex items-center gap-2.5">
                <img src={logo} alt="DIBRAL" className="h-8 w-8 rounded-md" />
                <span className="text-[var(--body-fg)] font-semibold tracking-tight">DIBRAL</span>
              </div>
              <p className="mt-5 text-sm text-[var(--body-fg)]/55 max-w-sm leading-relaxed">
                AI Automation That Grows Your Business. We build the silent AI workforce
                behind the next generation of ambitious SMBs.
              </p>

              <MagneticButton
                as="a"
                href="#booking"
                className="btn-primary mt-7"
                data-testid="footer-book-btn"
              >
                Book Free Consultation <ArrowUpRight className="w-4 h-4" />
              </MagneticButton>

              <form
                className="mt-7 flex items-center gap-2 max-w-sm"
                onSubmit={(e) => e.preventDefault()}
                data-testid="footer-newsletter"
              >
                <input
                  type="email"
                  required
                  placeholder="Your email for AI insights"
                  aria-label="Email for newsletter"
                  className="flex-1 rounded-full px-4 py-2.5 text-sm bg-[var(--eyebrow-bg)] border border-[var(--glass-border)] text-[var(--body-fg)] placeholder:text-[var(--body-fg)]/40 outline-none focus:border-[var(--card-hover-border)] transition"
                />
                <button type="submit" className="btn-primary !px-4 !py-2.5 text-sm">Subscribe</button>
              </form>
            </div>
          </Reveal>

          <Reveal direction="up" delay={0.08} className="md:col-span-7">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
              <FooterCol title="Services" links={[
                ["AI Websites", "#services"],
                ["WhatsApp AI", "#services"],
                ["CRM Automation", "#services"],
                ["Lead Management", "#services"],
                ["AI Support", "#services"],
                ["Dashboards", "#services"],
              ]} />
              <FooterCol title="Industries" links={[
                ["Real Estate", "#industries"],
                ["Clinics", "#industries"],
                ["Healthcare", "#industries"],
                ["Education", "#industries"],
                ["Automobile", "#industries"],
                ["Restaurants", "#industries"],
              ]} />
              <FooterCol title="Company" links={[
                ["About", "#founder"],
                ["Process", "#process"],
                ["Case Studies", "#case-studies"],
                ["FAQ", "#faq"],
                ["Contact", "#contact"],
                ["Book Consultation", "#booking"],
              ]} />
            </div>
          </Reveal>
        </div>

        <div className="mt-12 pt-6 border-t border-[var(--hairline)] flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-xs text-[var(--body-fg)]/45">
          <div>© {new Date().getFullYear()} DIBRAL — All rights reserved.</div>
          <div className="flex items-center gap-5">
            <a href="#" className="hover:text-[var(--body-fg)]/80 transition" data-testid="footer-privacy">Privacy Policy</a>
            <a href="#" className="hover:text-[var(--body-fg)]/80 transition" data-testid="footer-terms">Terms</a>
            <a href="mailto:Muditprataps20138@gmail.com" className="hover:text-[var(--body-fg)]/80 transition">Muditprataps20138@gmail.com</a>
          </div>
        </div>
      </div>

      {/* Giant brand wordmark */}
      <div className="overflow-hidden">
        <div className="select-none text-center font-serif italic leading-none text-[28vw] tracking-tighter text-transparent bg-clip-text bg-gradient-to-b from-[var(--body-fg)]/[0.06] to-[var(--body-fg)]/[0.005]">
          DIBRAL
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="text-[10px] font-mono uppercase tracking-widest text-[var(--body-fg)]/45 mb-4">{title}</div>
      <ul className="space-y-2.5">
        {links.map(([l, href]) => (
          <li key={l}>
            <a href={href} className="text-sm text-[var(--body-fg)]/70 hover:text-[var(--body-fg)] transition">{l}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}
